import AccessOffering from './AccessOffering';

export default AccessOffering;
